import { ShippingAddress } from '@ab-core/graphql/dist';

export enum DeliveryMethod {
    PICKUP = 'PICKUP',
    DELIVERY = 'DELIVERY',
    RETURN = 'RETURN',
    OFFER = 'OFFER',
    PROJECT = 'PROJECT'
}

// only the first letter in this enum is uppercase, because they are auto-generated this way
export enum CartShippingMethodInput {
    Pickup = 'PICKUP',
    Delivery = 'DELIVERY'
}

export type AddressFieldsProps = {
    address?: ShippingAddress;
    shippingMethod?: DeliveryMethod;
};
